import { Gql } from '@fiverr-private/dynamic_matching';
import { logger } from '../../../../utils/logger';
import { BudgetAndTimelineContent } from './types';

interface BuildFinalSectionContentParams {
    sectionContent: BudgetAndTimelineContent;
    needType: Gql.DmBriefNeedType;
    enableEnhancedUx?: boolean;
    ongoingWorkPotential?: boolean;
}

// clean unnecessary fields from the content
export const buildFinalSectionContent = ({
    sectionContent,
    needType,
    enableEnhancedUx = false,
    ongoingWorkPotential = false,
}: BuildFinalSectionContentParams): Partial<BudgetAndTimelineContent> => {
    const pricingType = sectionContent.pricingType || Gql.BriefPricingType.Fixed;

    const defaultEnrichment = enableEnhancedUx ? { ongoingWorkPotential } : {};

    if (!needType || needType === Gql.DmBriefNeedType.OneTime) {
        if (pricingType === Gql.BriefPricingType.Fixed) {
            return {
                pricingType,
                budgetInCents: sectionContent.budgetInCents,
                timeline: sectionContent.timeline,
                ...(sectionContent.timeline === Gql.DmBriefTimeline.SpecificDate && {
                    deliveryDate: sectionContent.deliveryDate,
                }),
                ...(sectionContent.timeline === Gql.DmBriefTimeline.GeneralTimeline && {
                    timelineDetails: {
                        generalTimeline: sectionContent?.timelineDetails?.generalTimeline,
                    },
                }),
                ...defaultEnrichment,
            };
        } else {
            return {
                pricingType,
                hourlyBudgetRange: sectionContent.hourlyBudgetRange,
                timeline: sectionContent.timeline,
                ...(sectionContent.timeline === Gql.DmBriefTimeline.SpecificDate && {
                    deliveryDate: sectionContent.deliveryDate,
                }),
                ...(sectionContent.timeline === Gql.DmBriefTimeline.GeneralTimeline && {
                    timelineDetails: {
                        generalTimeline: sectionContent?.timelineDetails?.generalTimeline,
                    },
                }),
                ...defaultEnrichment,
            };
        }
    } else if (pricingType === Gql.BriefPricingType.Fixed) {
        if (!sectionContent.timelineDetails?.deliveriesFrequency || !sectionContent.timelineDetails?.hiringDuration) {
            const errorMessage = 'Invalid state, timelineDetails is undefined or missing required fields';
            logger.error(errorMessage);
            throw new Error(errorMessage);
        }

        return {
            pricingType,
            budgetInCents: sectionContent.budgetInCents,
            timeline: Gql.DmBriefTimeline.Ongoing,
            timelineDetails: {
                deliveriesFrequency: sectionContent.timelineDetails.deliveriesFrequency,
                hiringDuration: sectionContent.timelineDetails.hiringDuration,
            },
            ...defaultEnrichment,
        };
    } else {
        if (!sectionContent.timelineDetails?.hiringDuration || !sectionContent.timelineDetails?.timeCommitment) {
            const errorMessage = 'Invalid state, timelineDetails is undefined or missing required fields';
            logger.error(errorMessage);
            throw new Error(errorMessage);
        }

        return {
            pricingType,
            hourlyBudgetRange: sectionContent.hourlyBudgetRange,
            timeline: Gql.DmBriefTimeline.Ongoing,
            timelineDetails: {
                hiringDuration: sectionContent.timelineDetails.hiringDuration,
                timeCommitment: sectionContent.timelineDetails.timeCommitment,
            },
            ...defaultEnrichment,
        };
    }
};
